import * as yup from 'yup';
import { CaseImpressionFileType } from '../../pages/DiffRetainer/modal/type';

export const DEFAULT_WIRE_SELECTION = [
    // '3 stranded round twisted wire',
    // 'Flat twisted wire',
    // 'placement jig in middle of wire',
    // 'placement jig on ends of wire'
    {
        // value : '3 stranded round twisted wire',
        value: 'Round Twist Wire',
        title: 'Round Twist Wire',
        description: 'Dentaurm 3 stranded round twisted wire. 0.45 mm',
    },
    {
        // value : 'Flat twisted wire',
        value: 'Flat Twist Wire',
        title: 'Flat Twist Wire',
        description: 'Leone flat twisted wire. 0.016 x 0.022 inch',
    },
];

export const BLEACHING_SELECTION = [
    {
        value: '4-4',
    },
    {
        value: '5-5',
    },
    {
        value: '6-6',
    },
];
export const LOWTRIMO_OPTIONS= [
    {
        value: '5-5',
    },
    {
        value: '4-4',
    },
    {
        value: '3-3',
    },
    {
        value: '2-2',
    },
];
export const BASE_RETAINER_OPTION = [
    {
        value: 'ecodontRetainers',
        label: 'Ecodont Retainers',
        forPatientHasFixedWire: true,
    },
    {
        value: 'ecodontRetainersWithWire',
        label: 'Ecodont Retainers with wire',
        forPatientHasFixedWire: false,
    },
    {
        value: 'MDLSmartFitRetainers',
        label: 'SmartFit Retainers',
        forPatientHasFixedWire: true,
    },
    {
        value: 'MDLSmartFitRetainersWithWire',
        label: 'SmartFit Retainers with wire',
        forPatientHasFixedWire: false,
        children: [
            {
                label: 'select',
                component: 'SelectRhf',
                // name: 'fixedPalatalWireSelect',
                // defaultValue: 'placement jig in middle of wire',
                // option: [
                //     "placement jig in middle of wire",
                //     "placement jig on ends of the wire"
                // ],
                name: 'smartFitWireSelect',
                // defaultValue: '3 stranded round twisted wire',
                defaultValue: 'Round Twist Wire',
                option: DEFAULT_WIRE_SELECTION,
            },
        ],
    },
    
    {
        value: 'ecodontRetainerWithVeneerShield_3set',
        label: 'Ecodont Retainers with Veneer Shield – 3 sets',
        forPatientHasFixedWire: true,
        children: [
            {
                label: 'LowTrimlineAreaLabel_3',
                component: 'SelectRhf',
                // name: 'fixedPalatalWireSelect',
                // defaultValue: 'placement jig in middle of wire',
                // option: [
                //     "placement jig in middle of wire",
                //     "placement jig on ends of the wire"
                // ],
                name: 'LowTrimlineAreaSelect_3',
                // defaultValue: '3 stranded round twisted wire',
                defaultValue: '4-4',
                option: LOWTRIMO_OPTIONS,
            },
        ],
    },
    {
        value: 'ecodontRetainerWithVeneerShield_1set',
        label: 'Ecodont Retainers with Veneer Shield – 1 set',
        forPatientHasFixedWire: true,
        children: [
            {
                label: 'LowTrimlineAreaLabel_1',
                component: 'SelectRhf',
                // name: 'fixedPalatalWireSelect',
                // defaultValue: 'placement jig in middle of wire',
                // option: [
                //     "placement jig in middle of wire",
                //     "placement jig on ends of the wire"
                // ],
                name: 'LowTrimlineAreaSelect_1',
                // defaultValue: '3 stranded round twisted wire',
                defaultValue: '4-4',
                option: LOWTRIMO_OPTIONS,
            },
        ],
    },
    {
        value: 'basicRetainers',
        label: 'Basic Retainers',
        forPatientHasFixedWire: true,
    },
    {
        value: 'bleachingRetainers',
        label: 'Bleaching Retainers',
        forPatientHasFixedWire: true,
        children: [
            {
                label: 'select',
                component: 'SelectRhf',
                name: 'bleachingRetainersSelect',
                defaultValue: '4-4',
                // option: ['4-4', '5-5', '6-6'],
                option: BLEACHING_SELECTION,
            },
        ],
    },
    {
        value: 'fixedPalatalWire',
        label: 'Fixed Palatal Wire',
        forPatientHasFixedWire: false,
        children: [
            {
                label: 'select',
                component: 'SelectRhf',
                // name: 'fixedPalatalWireSelect',
                // defaultValue: 'placement jig in middle of wire',
                // option: [
                //     "placement jig in middle of wire",
                //     "placement jig on ends of the wire"
                // ],
                name: 'palatalWireSelect',
                // defaultValue: '3 stranded round twisted wire',
                defaultValue: 'Round Twist Wire',
                option: [
                    ...DEFAULT_WIRE_SELECTION.map(String),
                    'placement jig in middle of wire',
                    'placement jig on ends of the wire',
                ],
            },
        ],
    },
];
export const archRententionVeneerShieldOption = [
    {
        // label:'Covering Lingual/Palatal Wire',
        value: 'coverLingualOrPalatalWire',
    },
    {
        // label:'Virtually remove lingual/palatal wire and make clear retainer',
        value: 'virtuallyRemoveLingualOrPalatalWire',
    },
    // {
    //     label:'Remove Buckle Bracket',
    //     value:'removeBuckleBracket'
    // },
];
export const archRententionOption = [
    {
        // label:'Covering Lingual/Palatal Wire',
        value: 'coverLingualOrPalatalWire',
    },
    {
        // label:'Do not cover Lingual/Palatal Wire',
        value: 'NotCoverLingualOrPalatalWire',
    },
    {
        // label:'Virtually remove lingual/palatal wire and make clear retainer',
        value: 'virtuallyRemoveLingualOrPalatalWire',
    },
    // {
    //     label:'Remove Buckle Bracket',
    //     value:'removeBuckleBracket'
    // },
];

export const ponticOption = [
    // {
    //     value: 'insertAPontic',
    //     label: 'Insert a pontic'
    // },
    // {
    //     value: 'doNotInsertAPontic',
    //     label: 'Do not insert a pontic'
    // },
    {
        value: 'colourPonticRequired',
        label: 'Tooth colour pontic is required',
    },
    {
        value: 'noPonticColour',
        label: 'No colour',
    },
    {
        value: 'sectionTheWireToIgnoreTheSpace',
        label: 'Section the wire to ignore the space',
    },
];

export const shadeColorOption = [
    'A1',
    'A2',
    'A3',
    'A3.5',
    'A4',
    'B1',
    'B2',
    'B3',
    'B4',
    'C1',
    'C2',
    'C3',
    'C4',
    'D2',
    'D3',
    'D4',
];

//Rule:
// value -- lower case
// label -- capital case
export const questions = {
    1: {
        question: 'Upload impression question?',
        name: 'archPosition',
        option: [
            {
                value: 'upper',
                label: 'Upper',
            },
            {
                value: 'lower',
                label: 'Lower',
            },
            {
                value: 'upperAndLower',
                label: 'Upper And Lower',
            },
        ],
        validation: yup.string().required('Required'),
    },
    2: {
        question: 'Does the patient currently have a fixed palatal/lingual wire?',
        name: 'fixedWire',
        option: [
            {
                value: 'true',
                label: 'yes',
            },
            {
                value: 'false',
                label: 'no',
            },
        ],
        defaultValue: 'false',
        // validation: yup.string().required('Required'),
    },
    3: {
        question: 'Please choose the arch to treat and the quantity of retainer you are ordering?',
        name: 'archAndQuantity',
        option: BASE_RETAINER_OPTION,
        validation: yup.string().required('Required'),
    },
    4: {
        question: 'Are occlusal/palatal bite ramps required?',
        name: 'occlusalBiteRampQuestion',
        option: [
            {
                value: 'false',
                label: 'biteRampNo',
            },
            {
                value: 'true',
                // label: 'Yes. Please specify the bite ramp position:'
                label: 'biteRampYes',
            },
        ],
    },
    '5A': {
        question: 'Clear Retainer Design Question U/L U&L',
        name: 'clearRetainerDesignUpper',
        label: 'Upper Arch Retention',
        value: false,
        children: {
            component: 'RadioRhf',
            name: 'clearRetainerDesignUpperOption',
            option: archRententionOption,
        },
    },
    '5B': {
        question: 'Clear Retainer Design Question U/L U&L',
        name: 'clearRetainerDesignLower',
        label: 'Lower Arch Retention',
        value: false,
        children: {
            component: 'RadioRhf',
            name: 'clearRetainerDesignLowerOption',
            option: archRententionOption,
        },
    },
    // "6A": {
    //     question: "Clear Retainer Design Question U/L/U&L for the second set of Ecodont Retainers with wire",
    //     name:'clearRetainerDesignUpperForSecondSet',
    //     label:'Upper Arch Retention',
    //     value:false,
    //     children:{
    //         component:'RadioRhf',
    //         name:"clearRetainerDesignUpperOptionForSecondSet",
    //         option:archRententionOption
    //     }
    // },
    // "6B": {
    //     question: "Clear Retainer Design Question U/L/U&L for the second set of Ecodont Retainers with wire",
    //     name:'clearRetainerDesignLowerForSecondSet',
    //     label:'Lower Arch Retention',
    //     value:false,
    //     children:{
    //         component:'RadioRhf',
    //         name:'clearRetainerDesignLowerOptionForSecondSet',
    //         option:archRententionOption
    //     }
    // },
    7: {
        question: 'Pontics',
        name: 'pontics',
        option: [
            {
                value: 'false',
                label: 'None',
            },
            {
                value: 'true',
                label: 'Please place pontic(s) in the tooth space(s) indicated:',
            },
        ],
    },
    8: {
        question: 'File Upload',
        name: 'impressionOption',
        option: [
            {
                value: CaseImpressionFileType.LATEST_APPROVED_TREATMENT_PLAN,
                label: 'DiffRetainer.formOptions.useLastStep',
            },
            {
                value: CaseImpressionFileType.FILE,
                label: 'NewPatient.impressions.uploadImpression',
            },
            {
                value: CaseImpressionFileType.LATEST_RETAINER_REQUEST,
                label: 'DiffRetainer.formOptions.useLastRetainerReq',
            },
        ],
    },
    9: {
        question: 'Special Instruction',
        name: 'specialInstructions',
    },
    pontic: {
        question: 'Pontic',
        name: 'pontic',
        option: ponticOption,
    },
    ponticColor: {
        question: 'Pontic Color',
        name: 'ponticColor',
        defaultValue: 'A2',
        option: shadeColorOption,
    },
};

export const upperAndLowerQuestionsFieldName = {
    UPPER: {
        // 1 : 'UpperArchPosition',
        2: 'UpperFixedWire',
        3: 'UpperArchAndQuantity',
        UpperBleachingRetainersSelect: 'UpperBleachingRetainersSelect',
        // "UpperFixedPalatalWireSelect" : 'UpperFixedPalatalWireSelect',
        UpperPalatalWireSelect: 'UpperPalatalWireSelect',
        UpperSmartFitWireSelect: 'UpperSmartFitWireSelect',
        UpperEcodontRetainersWithWire: 'UpperEcodontRetainersWithWire',
        UpperEcodontRetainerWithWire_1setSelect: 'UpperEcodontRetainerWithWire_1setSelect',
        UpperJigPlacementSelect: 'UpperJigPlacementSelect',
        UpperLowTrimlineAreaSelect_3: 'UpperLowTrimlineAreaSelect_3',
        UpperLowTrimlineAreaSelect_1: 'UpperLowTrimlineAreaSelect_1',
        4: 'UpperOcclusalBiteRampQuestion',
        '5A': 'UpperClearRetainerDesignUpper',
        '5A-opt': 'UpperClearRetainerDesignUpperOption',
        '5B': 'UpperClearRetainerDesignLower',
        '5B-opt': 'UpperClearRetainerDesignLowerOption',
        // '6A' : 'UpperClearRetainerDesignUpperForSecondSet',
        // '6A-opt' : 'UpperClearRetainerDesignUpperOptionForSecondSet',
        // '6B' : 'UpperClearRetainerDesignLowerForSecondSet',
        // '6B-opt' : 'UpperClearRetainerDesignLowerOptionForSecondSet',
        7: 'UpperPontics',
        UpperPontic: 'UpperPontic',
        UpperPonticColor: 'UpperPonticColor',
    },
    LOWER: {
        // 1 : 'LowerArchPosition',
        2: 'LowerFixedWire',
        3: 'LowerArchAndQuantity',
        LowerBleachingRetainersSelect: 'LowerBleachingRetainersSelect',
        // "LowerFixedPalatalWireSelect" : 'LowerFixedPalatalWireSelect',
        LowerPalatalWireSelect: 'LowerPalatalWireSelect',
        LowerSmartFitWireSelect: 'LowerSmartFitWireSelect',
        LowerEcodontRetainersWithWire: 'LowerEcodontRetainersWithWire',
        LowerEcodontRetainerWithWire_1setSelect: 'LowerEcodontRetainerWithWire_1setSelect',
        LowerJigPlacementSelect: 'LowerJigPlacementSelect',
        LowerLowTrimlineAreaSelect_3: 'LowerLowTrimlineAreaSelect_3',
        LowerLowTrimlineAreaSelect_1: 'LowerLowTrimlineAreaSelect_1',
        4: 'LowerOcclusalBiteRampQuestion',
        '5A': 'LowerClearRetainerDesignUpper',
        '5A-opt': 'LowerClearRetainerDesignUpperOption',
        '5B': 'LowerClearRetainerDesignLower',
        '5B-opt': 'LowerClearRetainerDesignLowerOption',
        // '6A' : 'LowerClearRetainerDesignUpperForSecondSet',
        // '6A-opt' : 'LowerClearRetainerDesignUpperOptionForSecondSet',
        // '6B' : 'LowerClearRetainerDesignLowerForSecondSet',
        // '6B-opt' : 'LowerClearRetainerDesignLowerOptionForSecondSet',
        7: 'LowerPontics',
        LowerPontic: 'LowerPontic',
        LowerPonticColor: 'LowerPonticColor',
    },
};

/**
 * @type {() => string[]}
 */
export const getFormKeysArray = (impressionType) => {
    switch (impressionType) {
        case 'upperAndLower':
            return [
                `UpperArchPosition`,
                upperAndLowerQuestionsFieldName.UPPER[2],
                upperAndLowerQuestionsFieldName.UPPER[3],
                upperAndLowerQuestionsFieldName.UPPER.UpperBleachingRetainersSelect,
                // upperAndLowerQuestionsFieldName.UPPER.UpperFixedPalatalWireSelect,
                upperAndLowerQuestionsFieldName.UPPER.UpperPalatalWireSelect,
                upperAndLowerQuestionsFieldName.UPPER.UpperSmartFitWireSelect,
                upperAndLowerQuestionsFieldName.UPPER.UpperEcodontRetainersWithWire,
                upperAndLowerQuestionsFieldName.UPPER.UpperEcodontRetainerWithWire_1setSelect,
                upperAndLowerQuestionsFieldName.UPPER.UpperJigPlacementSelect,
                upperAndLowerQuestionsFieldName.UPPER.UpperLowTrimlineAreaSelect_3,
                upperAndLowerQuestionsFieldName.UPPER.UpperLowTrimlineAreaSelect_1,
                upperAndLowerQuestionsFieldName.UPPER[4],
                'UpperBiteRamp',
                upperAndLowerQuestionsFieldName.UPPER['5A'],
                upperAndLowerQuestionsFieldName.UPPER['5A-opt'],
                upperAndLowerQuestionsFieldName.UPPER['5B'],
                upperAndLowerQuestionsFieldName.UPPER['5B-opt'],
                // upperAndLowerQuestionsFieldName.UPPER['6A'],
                // upperAndLowerQuestionsFieldName.UPPER['6A-opt'],
                // upperAndLowerQuestionsFieldName.UPPER['6B'],
                // upperAndLowerQuestionsFieldName.UPPER['6B-opt'],
                upperAndLowerQuestionsFieldName.UPPER[7],
                'UpperPontic',
                'UpperPonticColor',

                'LowerArchPosition',
                upperAndLowerQuestionsFieldName.LOWER[2],
                upperAndLowerQuestionsFieldName.LOWER[3],
                upperAndLowerQuestionsFieldName.LOWER.LowerBleachingRetainersSelect,
                // upperAndLowerQuestionsFieldName.LOWER.LowerFixedPalatalWireSelect,
                upperAndLowerQuestionsFieldName.LOWER.LowerPalatalWireSelect,
                upperAndLowerQuestionsFieldName.LOWER.LowerSmartFitWireSelect,
                upperAndLowerQuestionsFieldName.LOWER.LowerEcodontRetainersWithWire,
                upperAndLowerQuestionsFieldName.LOWER.LowerEcodontRetainerWithWire_1setSelect,
                upperAndLowerQuestionsFieldName.LOWER.LowerJigPlacementSelect,
                upperAndLowerQuestionsFieldName.LOWER.LowerLowTrimlineAreaSelect_3,
                upperAndLowerQuestionsFieldName.LOWER.LowerLowTrimlineAreaSelect_1,
                upperAndLowerQuestionsFieldName.LOWER[4],
                'LowerBiteRamp',
                upperAndLowerQuestionsFieldName.LOWER['5A'],
                upperAndLowerQuestionsFieldName.LOWER['5A-opt'],
                upperAndLowerQuestionsFieldName.LOWER['5B'],
                upperAndLowerQuestionsFieldName.LOWER['5B-opt'],
                // upperAndLowerQuestionsFieldName.LOWER['6A'],
                // upperAndLowerQuestionsFieldName.LOWER['6A-opt'],
                // upperAndLowerQuestionsFieldName.LOWER['6B'],
                // upperAndLowerQuestionsFieldName.LOWER['6B-opt'],
                upperAndLowerQuestionsFieldName.LOWER[7],
                'LowerPontic',
                'LowerPonticColor',
                // 'UseLatestApprovedTreatmentPlan',
            ];
        case 'upper':
        case 'lower':
            return [
                questions[1].name,
                questions[2].name,
                questions[3].name,
                'bleachingRetainersSelect',
                'palatalWireSelect',
                'smartFitWireSelect',
                'ecodontWireSelect',
                'jigPlacementSelect',
                'ecodontRetainerWithWire_1setSelect',
                'LowTrimlineAreaSelect_3',
                'LowTrimlineAreaSelect_1',
                questions[4].name,
                questions['5A'].name,
                'clearRetainerDesignUpperOption',
                questions['5B'].name,
                'clearRetainerDesignLowerOption',
                // questions['6A'].name,
                // 'clearRetainerDesignUpperOptionForSecondSet',
                // questions['6B'].name,
                // 'clearRetainerDesignLowerOptionForSecondSet',
                questions[7].name,
                // questions[8].name,
                'biteRamp',
                'pontic',
                'ponticColor',
                // 'UseLatestApprovedTreatmentPlan'
            ];
        default:
            throw new Error('Invalid impression type');
    }
};
